import { NotificationData, notifications } from "@mantine/notifications";
import { AxiosError } from "axios";
import { ReactNode } from "react";

import { Branch } from "./branch";

interface HandleErrorProps extends Omit<NotificationData, "message"> {
  title?: ReactNode;
  message?: ReactNode;
}

const isDebugMode = process.env.NODE_ENV !== "production";

export function handleError({
  title = "Operation failed",
  message = null,
  ...props
}: HandleErrorProps = {}) {
  return (error?: AxiosError) => {
    if (isDebugMode) console.error(error);
    message ??= <Branch data={error?.response?.data} />;

    notifications.show({
      color: "red.9",
      autoClose: 10 * 1000,
      styles: {
        description: {
          color: "var(--black)",
        },
      },
      ...props,
      message,
      title,
    });
  };
}
